import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "./api.service";

export interface IAccountResponse {
  payload: IAccountPayload;
  message: string;
}

export interface ISingleAccountResponse {
  payload: IAccountContent;
  message: string;
}

export interface IAccountPayload {
  content: IAccountContent[];
  page:    IAccountPage;
}


export interface IAccountContent {
  id: string;
  fullName: string;
  phoneNumber: string;
  email: string;
  roles: string[];
  lastLoginAt: Date| null;
  activatedAt: Date| null;
  profilePicture?: null;
  trackingLevel?: string,
  assignedLocations?: [
    {
      id: string;
      name: string;
      type: string;
      code: string;
    }
  ],
  occupation?: string;
}

export interface IAccountPage {
  size:          number;
  number:        number;
  totalElements: number;
  totalPages:    number;
}

export interface IUpdateStaffPayload {
  id?: string;
  fullName: string;
  email: string;
  phoneNumber: string;
  roleIds: string[];
  trackingLevel: string;
  assignedLocations: string[];
  profilePicture?: File;
}

export interface IToggleActiveResponse {
  payload: string;
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class AccountsService {
  constructor(private api: ApiService) {}

  getAccounts(page: number, size: number, search: string,organizationId?:string): Observable<IAccountResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('q', search);

    if (organizationId && organizationId.trim() !== '') {
      params = params.set('organizationId', organizationId);
    }

    return this.api.GET<IAccountResponse>('staff', { params });
  }

  updateAccountById(id: string, payload: IUpdateStaffPayload): Observable<IAccountResponse> {
    const formData = new FormData();

    // Append form data
    formData.append('fullName', payload.fullName);
    formData.append('email', payload.email);
    formData.append('phoneNumber', payload.phoneNumber);
    formData.append('trackingLevel', payload.trackingLevel);

    // Append arrays
    payload.roleIds.forEach(roleId => {
      formData.append('roleIds', roleId);
    });

    payload.assignedLocations.forEach(location => {
      formData.append('assignedLocations', location);
    });

    if (payload.profilePicture) {
      formData.append('profilePicture', payload.profilePicture);
    }

    return this.api.PATCH<IAccountResponse>(`staff/${id}`, formData);
  }

  toggleStaffActive(id: string): Observable<IToggleActiveResponse> {
    return this.api.PATCH<IToggleActiveResponse>(`staff/${id}/toggle-active`, {});
  }

  deleteStaff(id: string): Observable<IToggleActiveResponse> {
    return this.api.DELETE<IToggleActiveResponse>(`staff/${id}`);
  }

  getAccountById(id: string): Observable<ISingleAccountResponse> {
    return this.api.GET<ISingleAccountResponse>(`staff/${id}`);
  }

  downloadAccounts(): Observable<Blob> {
    return this.api.downloadFile('staff/download');
  }


}
